module.exports = __webpack_public_path__ + "static/img/consult_icon.f392b8e0.png";